import {createCachedSelector} from 're-reselect'
import {generatePath} from '@modifi/router'
import {getSubSectionsBySection} from '../../../utils/input-fields'
import {selectInputFieldsBySectionName} from '../../../modules/input-fields'
import {getRouteConfigForSection} from '../../../utils/route-configs'
import {STATIC_SECTIONS} from '../../../constants/section-to-input-fields'
import {NavigationItemEntry} from '../types'
import {
  SECTION_BWA_COMPANY_DOCUMENTS,
  SECTION_BWA_DOCUMENTS,
  SECTION_BWA_GROUP_DOCUMENTS,
  SECTION_YEARLY_CLOSING,
  SECTION_YEARLY_CLOSING_COMPANY,
  SECTION_YEARLY_CLOSING_GROUP,
} from '../../../constants/sections'

const selectStaticNavigationSubSectionsBySectionName = (
  state: any,
  sectionName: string
): string[] =>
  getSubSectionsBySection(sectionName)
    .map(subSectionName => {
      if (STATIC_SECTIONS.includes(subSectionName)) {
        return subSectionName
      }
      const inputFields = selectInputFieldsBySectionName(state, subSectionName)
      if (inputFields.length > 0) {
        return subSectionName
      }
      return null
    })
    .filter(Boolean) as string[]

export const selectStaticNavigationSubSections = createCachedSelector(
  selectStaticNavigationSubSectionsBySectionName,
  subSections =>
    subSections
      .map(subSectionName => {
        const routeConfig = getRouteConfigForSection(subSectionName)
        if (routeConfig) {
          let translationKey = `sub-section-menu.${subSectionName}`
          if (subSectionName === SECTION_YEARLY_CLOSING_COMPANY) {
            translationKey = `sub-section-menu.${SECTION_YEARLY_CLOSING}.company`
          } else if (subSectionName === SECTION_YEARLY_CLOSING_GROUP) {
            translationKey = `sub-section-menu.${SECTION_YEARLY_CLOSING}.group`
          } else if (subSectionName === SECTION_BWA_DOCUMENTS) {
            translationKey = `sub-section-menu.BWA`
          } else if (subSectionName === SECTION_BWA_COMPANY_DOCUMENTS) {
            translationKey = `sub-section-menu.BWA.company`
          } else if (subSectionName === SECTION_BWA_GROUP_DOCUMENTS) {
            translationKey = `sub-section-menu.BWA.group`
          }
          return {
            sectionName: subSectionName,
            translationKey,
            route: generatePath(routeConfig),
          }
        }
        return null
      })
      .filter(Boolean) as NavigationItemEntry[]
)((state, externalCompanyId, sectionName) => `${externalCompanyId}|${sectionName}`)
